import { LabelType } from "@/types";
import { formatLabel } from "@/utils/common";
import React from "react";

interface DetailedProps {
  series: number[];
  labels: string[];
  type: LabelType;
  dollar?: boolean;
}

const Detailed: React.FC<DetailedProps> = ({
  series,
  labels,
  type,
  dollar = true,
}) => {
  return (
    <div className="flex w-full flex-col justify-center gap-8 md:flex-row">
      <div className="legend-container mt-4 flex w-full flex-col items-center justify-center gap-4">
        <div className="grid w-full grid-cols-2 gap-3">
          {" "}
          {labels.map((label, index) => (
            <div key={index} className="space-y-1">
              <div className="flex w-full  md:justify-start">
                <div className="flex flex-col font-openSans text-[12px] font-semibold text-[#FFFFFF]">
                  {formatLabel(label, type)}
                </div>
              </div>
              <div className="font-openSans text-[12px] font-bold text-[#F0F0F0]">
                {dollar && "US$"}
                <span className="text-[16px] ">
                  {new Intl.NumberFormat("en-US").format(series[index])}{" "}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Detailed;
